module.exports = __webpack_public_path__ + "img/BY.e46a38bd.png";